import React, { useEffect, useState } from "react";
import style from "./../../assets/styles/_btnLearnMore.module.scss";

const BtnLearnMore = ({ children, color, baseColor, action, bgLinear, arrowSmall , sizeSmall}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className={`${style.btnLearnMore} ${arrowSmall ? style.arrowSmall : ""} ${sizeSmall ? style.sizeSmall : ""}`}
      style={{
        backgroundColor: isHovered ? baseColor : color,
        backgroundImage: bgLinear,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={action}
    >
      {children}
    </div>
  );
};

export default BtnLearnMore;
